import {NgModule} from '@angular/core';

import {VerticalLayoutModule} from 'app/layout/vertical/vertical.module';

@NgModule({
    imports: [
        VerticalLayoutModule,
    ],
    exports: [
        VerticalLayoutModule,
    ]
})
export class LayoutModule {
}
